import "./PropertySettings.style.css";

import React, { ChangeEvent } from "react";
import { PropertyState } from "../../../utils/states/ConstructorPageStates/PropertyState";
import { PropertyType } from "../../../utils/enums/PropertyType";
import { Status } from "../../../utils/enums/Status";

import numberType from "../../../resources/images/number_type.png";
import textType from "../../../resources/images/text_type.png";
import imageType from "../../../resources/images/image_type.png";
import dateType from "../../../resources/images/date_type.png";
import numberActiveType from "../../../resources/images/number_active_type.png";
import textActiveType from "../../../resources/images/text_active_type.png";
import imageActiveType from "../../../resources/images/image_active_type.png";
import dateActiveType from "../../../resources/images/date_active_type.png";

interface PropertySettingsProps {
  editedProperty: PropertyState;
  handleChangePropertyName: (newProperty: PropertyState) => void;
  handleChangePropertyType: (newProperty: PropertyState) => void;
  handleDeletePropertyClicked: () => void;
  propertySettingsRef: React.RefObject<HTMLDivElement | null>;
}

export const PropertySettings = ({
  editedProperty,
  handleChangePropertyName,
  handleChangePropertyType,
  handleDeletePropertyClicked,
  propertySettingsRef,
}: PropertySettingsProps) => {
  const { type } = editedProperty;

  const handleChangeType = (newType: PropertyType) => {
    handleChangePropertyType({
      ...editedProperty,
      type: newType,
      status: editedProperty.apiId ? Status.Update : editedProperty.status,
    });
  };

  const handleChangeName = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === "propertyName") {
      handleChangePropertyName({
        ...editedProperty,
        name: value,
        status: editedProperty.apiId ? Status.Update : editedProperty.status,
      });
    }
  };

  const getTypeText = (): string => {
    switch (type) {
      case PropertyType.String:
        return "Текст";
      case PropertyType.Date:
        return "Дата";
      case PropertyType.Image:
        return "Картинка";
      case PropertyType.Integer:
        return "Число";
      default:
        return "Число";
    }
  };

  return (
    <div ref={propertySettingsRef} className="property_settings_container">
      <div className="property_settings__title header_3">Настройка столбца</div>
      <div className="property_settings__input_block header_4">
        Название
        <input
          autoComplete="off"
          onChange={handleChangeName}
          name="propertyName"
          className="property_settings__input text_2"
          value={editedProperty.name}
        />
      </div>

      <div className="property_settings__type_block">
        <div className="property_settings__type_title header_4">
          {getTypeText()}
        </div>
        <div className="property_settings__property_type_buttons">
          <button
            onClick={() => handleChangeType(PropertyType.Integer)}
            className={
              type === PropertyType.Integer
                ? "property_settings__property_type_button active"
                : "property_settings__property_type_button"
            }
          >
            <img
              src={
                type === PropertyType.Integer ? numberActiveType : numberType
              }
              alt="number type"
            />
          </button>
          <button
            onClick={() => handleChangeType(PropertyType.String)}
            className={
              type === PropertyType.String
                ? "property_settings__property_type_button active"
                : "property_settings__property_type_button"
            }
          >
            <img
              src={type === PropertyType.String ? textActiveType : textType}
              alt="text type"
            />
          </button>
          <button
            onClick={() => handleChangeType(PropertyType.Image)}
            className={
              type === PropertyType.Image
                ? "property_settings__property_type_button active"
                : "property_settings__property_type_button"
            }
          >
            <img
              src={type === PropertyType.Image ? imageActiveType : imageType}
              alt="image_type"
            />
          </button>
          <button
            onClick={() => handleChangeType(PropertyType.Date)}
            className={
              type === PropertyType.Date
                ? "property_settings__property_type_button active"
                : "property_settings__property_type_button"
            }
            disabled={true}
          >
            <img
              src={type === PropertyType.Date ? dateActiveType : dateType}
              alt="date type"
            />
          </button>
        </div>
      </div>

      <div className="property_settings__buttons">
        <button
          onClick={handleDeletePropertyClicked}
          className="property_settings__delete_button header_4"
        >
          Удалить столбец
        </button>
      </div>
    </div>
  );
};
